const translations = {
    en: {
        restaurants: {
            venues_cards_slider: {
                title: "If you want to eat downtown...",
                rating: "Rating:",
                view_on_maps: "VIEW ON MAP"
            }
        }
    },
    de: {
        restaurants: {
            venues_cards_slider: {
                title: "Wenn Sie in der Innenstadt essen wollen...",
                rating: "Bewertung:",
                view_on_maps: "SCHAUEN SIE AUF DIE KARTE"
            }
        }
    },
    es: {
        restaurants: {
            venues_cards_slider: {
                title: "Si quiere comer afuera...",
                rating: "Evaluacion :",
                view_on_maps: "VER EN EL MAPA"
            }
        }
    },
    fr: {
        restaurants: {
            venues_cards_slider: {
                title: "Si vous voulez manger dehors...",
                rating: "Evaluation:",
                view_on_maps: "VOYEZ LE PLAN"
            }
        }
    },
    it: {
        restaurants: {
            venues_cards_slider: {
                title: "Altre alternative in zona...",
                rating: "Valutazione:",
                view_on_maps: "GUARDA LA MAPPA"
            }
        }
    }
};

export default translations;


// WEBPACK FOOTER //
// ./translations/restaurants/VenuesCardsSlider.js